// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Clipboard } from "@capacitor/clipboard";
import { Text, Title } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import { Card, CardContent, Stack } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";

import { IconButton } from "../../../../redesign/components/IconButton";
import { WorkplaceReferralAction, WorkplaceReferralComponent } from "../../types";

interface WorkplaceReferralsListCardsProps {
  workplaceName: string;
  workplaceUserName: string;
  workplaceUserEmail: string;
  bonusAmount?: number;
}

export function WorkplaceReferralsListCard(props: WorkplaceReferralsListCardsProps) {
  const { showSuccessToast } = useToast();
  const { workplaceName, workplaceUserName, workplaceUserEmail, bonusAmount } = props;
  const handleCopyEmail = async () => {
    await Clipboard.write({
      string: workplaceUserEmail,
    });
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL_STATS, {
      action: WorkplaceReferralAction.REFERRAL_STATS_EMAIL_COPIED,
      component: WorkplaceReferralComponent.WORKPLACE_REFERRAL_STATS_LIST_ITEM,
    });
    showSuccessToast("Email copied successfully");
  };
  return (
    <Card>
      <CardContent>
        <Stack spacing={4}>
          <Title component="h6">{workplaceName}</Title>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2} alignItems="center">
              <PersonIcon fontSize="small" />
              <Text variant="body1">{workplaceUserName}</Text>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center">
              <EmailIcon fontSize="small" />
              <Text variant="body1">{workplaceUserEmail}</Text>
              <IconButton
                iconType="copy"
                variant="ghost"
                size="small"
                sx={{ width: "20px", height: "20px", paddingLeft: 3 }}
                onClick={handleCopyEmail}
              />
            </Stack>

            {isDefined(bonusAmount) ? (
              <Stack direction="row" spacing={1} alignItems="center">
                <AttachMoneyIcon fontSize="small" />
                <Text variant="body1">{bonusAmount} Earned</Text>
              </Stack>
            ) : null}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
